import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../mock';

const Navbar = ({ onBookConsult }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('Home');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0B1430]/95 backdrop-blur-sm shadow-lg' : 'bg-[#0B1430]'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[92px] flex items-center justify-between">
        {/* Logo — whole uploaded logo shown as-is */}
        <a href="#home" className="flex items-center shrink-0">
          <img
            src="/logo.png"
            alt="Future Smarter Lighting"
            className="h-16 lg:h-[72px] w-auto object-contain drop-shadow-[0_0_18px_rgba(212,168,83,0.35)]"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.name}
              href={l.href}
              onClick={() => setActive(l.name)}
              className={`nav-link text-[14px] font-medium ${
                active === l.name ? 'active text-[#D4A853]' : 'text-white/90'
              }`}
            >
              {l.name}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <button
          onClick={onBookConsult}
          className="hidden lg:inline-flex items-center px-5 py-3 rounded-md bg-[#D4A853] hover:bg-[#B8893A] text-[#0B1430] font-semibold text-[13px] transition-colors duration-300"
        >
          Book a Free Consultation
        </button>

        {/* Mobile menu trigger */}
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#0B1430] border-t border-white/10">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <a
                key={l.name}
                href={l.href}
                onClick={() => { setActive(l.name); setOpen(false); }}
                className="text-white/90 hover:text-[#D4A853] py-1.5 text-sm"
              >
                {l.name}
              </a>
            ))}
            <button
              onClick={() => { setOpen(false); onBookConsult(); }}
              className="mt-2 w-full px-5 py-3 rounded-md bg-[#D4A853] hover:bg-[#B8893A] text-[#0B1430] font-semibold text-sm transition-colors"
            >
              Book a Free Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
